module.exports = __webpack_public_path__ + "media/DINPro-Condensed-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Condensed/DINPro-Condensed-Bold.ttf
// module id = 1571
// module chunks = 57